import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";

const SettlementsApiService = {
  getMySettlements: async () => {
    const response = await api.request({
      url: `/api/Settlements/GetMySettlements`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getSettlements: async (filters) => {
    const response = await api.request({
      url: `/api/Settlements/GetSettlements?${queryString.stringify(
        filters || {}
      )}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  requestSettlement: async (settlementData) => {
    const response = await api.request({
      url: `/api/Settlements/RequestSettlement`,
      method: "POST",
      data: settlementData,
      headers: authHeader(),
    });
    return response.data;
  },

  approveSettlement: async (settlementId) => {
    const response = await api.request({
      url: `/api/Settlements/ApproveSettlement?id=${settlementId}`,
      method: "PUT",
      headers: authHeader(),
    });
    return response.data;
  },

  rejectSettlement: async (settlementId, reason) => {
    const response = await api.request({
      url: `/api/Settlements/RejectSettlement?id=${settlementId}&reason=${encodeURIComponent(
        reason
      )}`,
      method: "PUT",
      headers: authHeader(),
    });
    return response.data;
  },

  completeSettlement: async (settlementId) => {
    const response = await api.request({
      url: `/api/Settlements/CompleteSettlement?id=${settlementId}`,
      method: "PUT",
      headers: authHeader(),
    });
    return response.data;
  },
};

export default SettlementsApiService;
